import { isEmpty } from 'lodash';
import { array } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Skeleton, Slide, Slider, StrapiImg, useHomePageContext } from 'components';
import { isBreakpoint } from 'helpers';

const FeaturedProducts = ({ products }) => {
  const { t } = useTranslation();
  const { homePageLoading, pageType } = useHomePageContext();
  const isDesktop = isBreakpoint(1024);

  return (
    <div>
      {homePageLoading && (
        <>
          <Skeleton classNames="w-1/2 h-8 md:w-1/3" />
          <Skeleton classNames="w-full h-36 md:h-96" />
        </>
      )}

      {!homePageLoading && !isEmpty(products) && (
        <>
          <h2 className="h2 underlined-yellow">{t(`home.${pageType}.rightNow`)}</h2>

          <Slider
            type="loop"
            options={{ perPage: 1, perMove: 1, clones: 1, autoplay: true, interval: 5000 }}
            sliderClass="absolute-arrows center lg:aspect-[3/1]"
          >
            {products.map((slide, i) => (
              <Slide key={`slider-current-offer-${i}`}>
                <Link to={slide?.linkCta?.link ?? null} className="w-full h-full block">
                  <StrapiImg
                    className="w-full h-full object-cover rounded-2xl cursor-pointer"
                    image={isDesktop ? slide.desktopImage : slide.mobileImage}
                  />
                </Link>
              </Slide>
            ))}
          </Slider>
        </>
      )}
    </div>
  );
};

FeaturedProducts.propTypes = {
  products: array.isRequired
};

export default FeaturedProducts;
